import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { createFileRoute, /*isNotFound, */ Outlet } from '@tanstack/react-router';
import { AutoResetDonationFlow } from './-components/flows/auto-reset-donation-flow';
import { UpdatePortalOnConfirmedDonationFlow } from './-components/flows/update-portal-on-confirmed-donation-flow';
import { FormTranslationsProvider } from '../-components/form-translations-provider';
import { lazy, Suspense } from 'react';
// import { usePortalMetadataQuery } from '@/lib/data-hooks';
// import { NotFound } from '../-components/not-found';

const StandaloneDonationsFlow = lazy(() =>
	import('./-components/flows/standalone-donations-flow').then((m) => ({ default: m.StandaloneDonationsFlow })),
);

export const Route = createFileRoute('/$portalId')({
	component: RouteComponent,
});

/**
 * TODO: recover this when we have a better strategy for handling 404s on SSR streaming. See the comment in `RouteComponent` below for details.
 */
// Suspends the whole route on the portal metadata query. When the portal doesn't
// exist we return `<NotFound />` directly rather than `throw notFound()` — on SSR
// streaming, React treats a render-phase throw here as an uncaught error and
// switches the whole tree to client rendering ("server rendering errored:
// {isNotFound: true}"). Returning the component plays nicely with streaming.
//
// The loader stays fire-and-forget — the render suspends on the React Query
// entry kicked off by the child loaders. On client navigations where metadata
// is already cached, this hook returns synchronously and the route renders
// immediately with its per-component skeletons.
function RouteComponent() {
	// const metadata = usePortalMetadataQuery();
	const { iframe } = Route.useSearch();

	// if (isNotFound(metadata)) {
	// 	return (
	// 		<I18nProvider i18n={i18n}>
	// 			<NotFound />
	// 		</I18nProvider>
	// 	);
	// }

	return (
		<I18nProvider i18n={i18n}>
			<FormTranslationsProvider>
				<AutoResetDonationFlow />
				{iframe && (
					<Suspense>
						<StandaloneDonationsFlow />
					</Suspense>
				)}
				<UpdatePortalOnConfirmedDonationFlow />
				<Outlet />
			</FormTranslationsProvider>
		</I18nProvider>
	);
}
